module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/funabashi_ekimae_point3_5-eb9af558b9bdf178905c0f216601c1da.jpg";